import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "./Navbar";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import SearchIcon from "@mui/icons-material/Search";
import Header from "./header";
import DatePicker from "react-datepicker";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "moment/locale/th";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ApiConfig from "../../common/config/ApiConfig";
import { useLanguage } from "../../common/i18n/LanguageContext";

function Limitnumber() {
  const { t } = useLanguage();
  const [limitnum, setLimitnum] = useState([]);
  const [lottoTypes, setLottoTypes] = useState([]);
  const [rewardTypeGroups, setRewardTypeGroups] = useState([]);
  const user = localStorage.getItem("user");
  const [startDate, setStartDate] = useState(new Date());
  const [lottotype, setLottotype] = useState("th_gov");
  const [open, setOpen] = useState(false);
  const [openedit, setOpenedit] = useState(false);
  const [lottoid, setLottoid] = useState(false);

  const [number, setNumber] = useState("");
  const [numbertype, setNumbertype] = useState("first");
  const [limitpayrate, setLimitpayrate] = useState(0);
  const [roundofday, setRoundofday] = useState(1);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const limitnumget = async () => {
    const params = new URLSearchParams({
      agent: user,
      lotto_type: lottotype,
      res_date: moment(startDate).format("YYYY-MM-DD"),
      page: page,
      limit: limit,
    });
    await ApiConfig.get(`/Getlimitnumber?${params.toString()}`).then(
      (result) => {
        if (result.resCode !== 200) {
          toast.error(result.message || t("common_load_error"), {
            autoClose: 2000,
          });
          return;
        }
        setLimitnum(result.data);
      },
    );
  };
  useEffect(() => {
    limitnumget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lottotype, startDate, page, limit]);

  useEffect(() => {
    setPage(1);
  }, [lottotype, startDate]);

  const fetchLottoTypes = () => {
    ApiConfig.get("/getLottoTypes", {}).then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          autoClose: 2000,
        });
        return;
      }
      setLottoTypes(Array.isArray(result.data) ? result.data : []);
    });
  };

  useEffect(() => {
    fetchLottoTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Every "number type" a limit-number row can target comes from the reward
  // type catalog itself (groups → rewardTypes, each with the exact `code`
  // /Getlimitnumber's rows use as `number_type`), deduplicated by code —
  // a lotto type can have the same stake code attached to more than one
  // group.
  const fetchRewardTypeGroups = () => {
    ApiConfig.get("/getLottoRewardTypeGroups").then((result) => {
      if (result.resCode !== 200) {
        toast.error(result.message || t("common_load_error"), {
          autoClose: 2000,
        });
        return;
      }
      setRewardTypeGroups(Array.isArray(result.data) ? result.data : []);
    });
  };

  useEffect(() => {
    fetchRewardTypeGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const numberTypeOptions = rewardTypeGroups
    .filter((g) => g.lottoType?.type === lottotype)
    .reduce((acc, g) => {
      const existingCodes = new Set(acc.map((rt) => rt.code));
      const fresh = (g.rewardTypes || []).filter(
        (rt) => !existingCodes.has(rt.code),
      );
      return [...acc, ...fresh];
    }, []);

  const rewardTypeNameByCode = rewardTypeGroups.reduce((acc, g) => {
    (g.rewardTypes || []).forEach((rt) => {
      if (!(rt.code in acc)) acc[rt.code] = rt.name;
    });
    return acc;
  }, {});

  const roundOptions =
    lottoTypes.find((lt) => lt.type === lottotype)?.rounds || [];

  useEffect(() => {
    const match = lottoTypes.find((lt) => lt.type === lottotype);
    const firstRound = match?.rounds?.[0]?.round;
    if (firstRound != null) setRoundofday(firstRound);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lottotype, lottoTypes]);

  const hasNextPage = limitnum.length === limit;

  useEffect(() => {
    if (
      numberTypeOptions.length &&
      !numberTypeOptions.some((item) => item.code === numbertype)
    ) {
      setNumbertype(numberTypeOptions[0].code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lottotype, rewardTypeGroups]);

  const isDateSelectable = (date) => {
    if (lottotype === "th_gov") {
      const day = date.getDate();
      return day === 1 || day === 16;
    }
    if (lottotype === "laos_gov") {
      const dayOfWeek = date.getDay();
      return dayOfWeek >= 1 && dayOfWeek <= 5;
    }
    return true;
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseedit = () => {
    setNumber();
    setLottoid("");
    setLimitpayrate(0);
    setOpenedit(false);
  };
  const handleOpenedit = (number, id, rate) => {
    setLottoid(id);
    setNumber(number);
    setLimitpayrate(rate);
    setOpenedit(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpen(false);
    const jsonforinsert = {
      agent: user,
      lotto_type: lottotype,
      result_date: moment(startDate).format("YYYY-MM-DD"),
      number: number,
      number_type: numbertype,
      limit_payrate: parseInt(limitpayrate),
      round_of_day: roundofday,
    };

    // Check for empty or undefined fields
    const emptyFields = Object.keys(jsonforinsert).filter(
      (key) =>
        jsonforinsert[key] === null ||
        jsonforinsert[key] === undefined ||
        jsonforinsert[key] === "",
    );

    if (emptyFields.length > 0) {
      Swal.fire({
        title: t("limitnumber_incomplete_title"),
        text: t("member_fill_all_fields"),
        icon: "error",
      });
      return;
    }

    const confirmationMessage = `${t("limitnumber_add_confirm_prefix")} ${
      jsonforinsert.number
    } ${t("limitnumber_add_confirm_lotto_prefix")} ${jsonforinsert.lotto_type} ${t(
      "limitnumber_add_confirm_date_prefix",
    )} ${jsonforinsert.result_date} ${t(
      "limitnumber_add_confirm_reward_prefix",
    )} ${jsonforinsert.limit_payrate}?`;

    Swal.fire({
      title: t("common_are_you_sure"),
      text: confirmationMessage,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (result.isConfirmed) {
        ApiConfig.post("/addlimitnum", jsonforinsert)
          .then((result) => {
            if (result.resCode === 200) {
              toast.success(t("limitnumber_add_success"), {
                autoClose: 2000,
              });
              limitnumget();
            } else {
              toast.error(result.message || t("limitnumber_add_error"), {
                autoClose: 2000,
              });
            }
          })
          .catch(() => {
            toast.error(t("limitnumber_add_error"), { autoClose: 2000 });
          });
      }
    });
  };

  const deletelimit = (id) => {
    Swal.fire({
      title: t("common_are_you_sure"),
      text: t("limitnumber_delete_confirm_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (result.isConfirmed) {
        ApiConfig.post("/dellimitnum", { limitid: id })
          .then((result) => {
            if (result.resCode === 200) {
              toast.success(t("limitnumber_delete_success"), {
                autoClose: 2000,
              });
              limitnumget();
            } else {
              toast.error(result.message || t("limitnumber_delete_error"), {
                autoClose: 2000,
              });
            }
          })
          .catch(() => {
            toast.error(t("limitnumber_delete_error"), { autoClose: 2000 });
          });
      }
    });
  };

  const updatelimit = (e) => {
    e.preventDefault();
    const json = {
      rate: limitpayrate,
      limitid: lottoid,
    };

    Swal.fire({
      title: t("common_are_you_sure"),
      text: `${t("limitnumber_edit_confirm_prefix")} ${number} ${t(
        "limitnumber_edit_confirm_middle",
      )} ${limitpayrate}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      ApiConfig.post("/updatelimitnum", json)
        .then((result) => {
          if (result.resCode === 200) {
            toast.success(t("limitnumber_edit_success"), {
              autoClose: 2000,
            });
            limitnumget();
            handleCloseedit();
          } else {
            toast.error(result.message || t("limitnumber_edit_error"), {
              autoClose: 2000,
            });
          }
        })
        .catch(() => {
          toast.error(t("limitnumber_edit_error"), { autoClose: 2000 });
        });
    });
  };

  const renderNumberTypeCell = (numberType) =>
    rewardTypeNameByCode[numberType] || numberType || "";

  const renderLottoTypeCell = (lottoType) => {
    switch (lottoType) {
      case "th_gov":
        return t("lotto_type_th_gov");
      case "laos_gov":
        return t("lotto_type_laos_gov");
      case "hanoy_PhuQua":
        return t("lotto_type_hanoi");
      case "Yeekee_5":
        return t("table_lotto_yeekee5");
      case "Yeekee_10":
        return t("table_lotto_yeekee10");
      case "Yeekee_15":
        return t("table_lotto_yeekee15");
      default:
        return "";
    }
  };

  const pos = localStorage.getItem("position");

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("menu_limit_number")} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <div className="w-[100%] md:w-[100%] h-[50px] my-3 bg-sky-300 rounded flex flex row">
              <div className="bg-yellow-500 p-2 rounded w-[35px]">
                <SearchIcon className="text-white" />
              </div>

              <div className="flex flex-col ml-3">
                <span className="text-white text-[10px] font-bold ml-1">
                  {t("limitnumber_period_label")}
                </span>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  filterDate={isDateSelectable}
                />
              </div>

              <div className="flex flex-col ml-3">
                <span className="text-white text-[10px] font-bold ml-1">
                  {t("lotto_service_col_type")}
                </span>
                <select
                  value={lottotype}
                  onInput={(e) => setLottotype(e.target.value)}
                >
                  {lottoTypes.map((lt) => (
                    <option key={lt.id} value={lt.type}>
                      {lt.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="p-1 mb-1 h-[2em] w-[10%] text-center rounded border-solid bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border-brand-gold-200 shadow-gold hover:brightness-105 ">
              <FormatListNumberedIcon className="ml-1 text-[8px] md:text-[16px]" />
              <span
                className="ml-1 text-[8px] md:text-[16px]"
                onClick={handleClickOpen}
              >
                {t("limitnumber_add_button")}
              </span>
            </div>
            <div className="rounded overflow-hidden mt-1 overflow-x-auto">
              <table className="w-full text-[14px] border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="py-1 px-2 text-sm" width="50">
                      {t("membertable_col_no")}
                    </th>
                    <th className="py-1 px-2 text-sm">
                      {t("limitnumber_col_number")}
                    </th>
                    <th className="py-1 px-2 text-sm">
                      {t("table_filter_by_bet_type")}
                    </th>
                    <th className="py-1 px-2 text-sm">
                      {t("commission_step_reward_label")}
                    </th>
                    <th className="py-1 px-2 text-sm">
                      {t("lotto_service_col_type")}
                    </th>
                    <th className="py-1 px-2 text-sm">
                      {t("limitnumber_draw_label")}
                    </th>
                    <th className="py-1 px-2 text-sm">
                      {t("limitnumber_col_result_round")}
                    </th>
                    <th className="py-1 px-2 text-sm">{t("common_edit")}</th>
                  </tr>
                </thead>
                <tbody>
                  {limitnum.map((row, index) => (
                    <tr
                      key={row.id ?? index}
                      className={`transition-colors ${
                        index % 2 === 0 ? "bg-gray-50" : "bg-gray-200"
                      } hover:bg-gray-300`}
                    >
                      <td className="p-2 text-center">{index + 1}</td>
                      <td className="p-2 text-center">{row.number}</td>
                      <td className="p-2 text-center">
                        {renderNumberTypeCell(row.number_type)}
                      </td>
                      <td className="p-2 text-center">{row.limit_payrate}</td>
                      <td className="p-2 text-center">
                        {renderLottoTypeCell(row.lotto_type)}
                      </td>
                      <td className="p-2 text-center">
                        {row.result_date
                          ? moment(row.result_date).format("ll")
                          : ""}
                      </td>
                      <td className="p-2 text-center">{row.round_of_day}</td>
                      <td className="p-2 text-center">
                        <Button
                          onClick={() =>
                            handleOpenedit(
                              row.number,
                              row.id,
                              row.limit_payrate,
                            )
                          }
                        >
                          {t("common_edit")}
                        </Button>
                        <Button onClick={() => deletelimit(row.id)}>
                          {t("common_delete")}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="flex items-center justify-between mt-2 px-1">
              <div className="flex items-center gap-2">
                <label className="font-bold text-sm">
                  {t("common_per_page")}
                </label>
                <select
                  className="p-1 border border-gray-300 rounded text-sm"
                  value={limit}
                  onChange={(e) => {
                    setLimit(Number(e.target.value));
                    setPage(1);
                  }}
                >
                  {[10, 20, 50, 100].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  disabled={page <= 1}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  className="py-1 px-3 bg-blue-500 text-white rounded text-sm disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  {t("common_page_previous")}
                </button>
                <span className="font-bold text-sm">
                  {t("commission_page_label")} {page}
                </span>
                <button
                  type="button"
                  disabled={!hasNextPage}
                  onClick={() => setPage((p) => p + 1)}
                  className="py-1 px-3 bg-blue-500 text-white rounded text-sm disabled:opacity-40 disabled:cursor-not-allowed"
                >
                  {t("common_next")}
                </button>
              </div>
            </div>
            {open && (
              <div>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <div className="App">
                    <form onSubmit={handleSubmit}>
                      <DialogTitle
                        className="text-white bg-brand-blue-800"
                        id="alert-dialog-title"
                      >
                        {t("limitnumber_add_button")}
                      </DialogTitle>
                      <DialogContent className="p-1">
                        <div className="register">
                          <div className="flex flex-col mb-4">
                            <label
                              className="mb-2 font-bold text-lg text-gray-900"
                              htmlFor="lottotype"
                            >
                              {t("lotto_service_col_type")}
                            </label>
                            <select
                              className="border py-2 px-3 text-grey-800"
                              id="numbertype"
                              value={lottotype}
                              onInput={(e) => setLottotype(e.target.value)}
                            >
                              {lottoTypes.map((lt) => (
                                <option key={lt.id} value={lt.type}>
                                  {lt.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="flex flex-row gap-4 mb-4">
                            <div className="flex flex-col">
                              <label
                                className="mb-2 font-bold text-lg text-gray-900"
                                htmlFor="startDate"
                              >
                                {t("limitnumber_draw_label")}
                              </label>
                              <DatePicker
                                className="border py-2 px-3 text-grey-800"
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                filterDate={isDateSelectable}
                              />
                            </div>
                            <div className="flex flex-col">
                              <label className="mb-2 font-bold text-lg text-gray-900">
                                {t("lotto_service_round_prefix")}
                              </label>
                              <select
                                className="border py-2 px-3 text-grey-800"
                                value={roundofday}
                                onChange={(e) => setRoundofday(e.target.value)}
                              >
                                {roundOptions.map((r) => (
                                  <option key={r.id} value={r.round}>
                                    {r.round}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="flex flex-col mb-4">
                            <label
                              className="mb-2 font-bold text-lg text-gray-900"
                              htmlFor="numbertype"
                            >
                              {t("table_filter_by_bet_type")}
                            </label>
                            <select
                              className="border py-2 px-3 text-grey-800"
                              id="numbertype"
                              value={numbertype}
                              onChange={(e) => setNumbertype(e.target.value)}
                            >
                              {numberTypeOptions.map((item) => (
                                <option key={item.id} value={item.code}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="flex flex-col mb-4">
                            <label
                              className="mb-2 font-bold text-lg text-gray-900"
                              htmlFor="number"
                            >
                              {t("limitnumber_col_number")}
                            </label>
                            <input
                              className="border py-2 px-3 text-grey-800"
                              type="text"
                              id="number"
                              placeholder={t("limitnumber_placeholder")}
                              onChange={(e) => setNumber(e.target.value)}
                            />
                          </div>

                          <div className="flex flex-col mb-4">
                            <label
                              className="mb-2 font-bold text-lg text-gray-900"
                              htmlFor="limitpayrate"
                            >
                              {t("limitnumber_reward_label")}
                            </label>
                            <input
                              className="border py-2 px-3 text-grey-800"
                              type="number"
                              id="limitpayrate"
                              placeholder={t("commission_step_reward_label")}
                              value={limitpayrate}
                              onChange={(e) => setLimitpayrate(e.target.value)}
                            />
                          </div>
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <button
                          type="submit"
                          className="bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border border-brand-gold-200 shadow-gold hover:brightness-105 font-bold py-2 px-4 mr-1 rounded"
                        >
                          <SaveAltIcon /> {t("membertable_save")}
                        </button>
                        <button
                          onClick={handleClose}
                          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                        >
                          {t("common_cancel")}
                        </button>
                      </DialogActions>
                    </form>
                  </div>
                </Dialog>
              </div>
            )}
            {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

            {openedit && (
              <div>
                <Dialog
                  open={openedit}
                  onClose={handleCloseedit}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <div className="App">
                    <form onSubmit={updatelimit}>
                      <DialogTitle id="alert-dialog-title">
                        {t("limitnumber_edit_title")}
                      </DialogTitle>
                      <DialogContent>
                        <div className="register">
                          <span>{t("limitnumber_col_number")} </span>
                          <h2>{number}</h2>

                          <span>{t("limitnumber_reward_label")}</span>
                          <input
                            type="number"
                            placeholder={t("commission_step_reward_label")}
                            value={limitpayrate}
                            onChange={(e) => setLimitpayrate(e.target.value)}
                          />
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <Button type="submit">{t("common_update")}</Button>
                        <Button onClick={handleCloseedit}>
                          {t("common_close")}
                        </Button>
                      </DialogActions>
                    </form>
                  </div>
                </Dialog>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Limitnumber;
